var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStatementIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 22.75H6.5C5.63805 22.75 4.8114 22.4076 4.2019 21.7981C3.59241 21.1886 3.25 20.362 3.25 19.5V18.4167H14.0833V20.5833C14.0833 21.158 14.3116 21.7091 14.7179 22.1154C15.1243 22.5217 15.6754 22.75 16.25 22.75ZM16.25 22.75C16.8246 22.75 17.3757 22.5217 17.7821 22.1154C18.1884 21.7091 18.4167 21.158 18.4167 20.5833V5.41667C18.4167 4.98814 18.5437 4.56924 18.7818 4.21293C19.0199 3.85663 19.3583 3.57892 19.7542 3.41493C20.1501 3.25094 20.5857 3.20803 21.006 3.29163C21.4263 3.37523 21.8124 3.58159 22.1154 3.8846C22.4184 4.18762 22.6248 4.57368 22.7084 4.99397C22.792 5.41426 22.7491 5.84991 22.5851 6.24582C22.4211 6.64172 22.1434 6.98011 21.7871 7.21819C21.4308 7.45626 21.0119 7.58333 20.5833 7.58333H18.4167M20.5833 3.25H8.66667C7.80471 3.25 6.97806 3.59241 6.36857 4.2019C5.75908 4.8114 5.41667 5.63805 5.41667 6.5V18.4167",
    stroke: "#008FC3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 7.5835H14.0833",
    stroke: "#F49600",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 11.9165H14.0833",
    stroke: "#F49600",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatementIcon);
export default __webpack_public_path__ + "static/media/StatementIcon.e84ce0c258c38ae269d29dd57649857d.svg";
export { ForwardRef as ReactComponent };